import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ConfirmedRegistration, consultarInscricaoConfirmada } from './formularioParts/api';
import { SuccessScreen } from './formularioParts/SuccessScreen';

const PagamentoSucesso: React.FC = () => {
  const { registrationId } = useParams<{ registrationId: string }>();
  const navigate = useNavigate();
  const [registration, setRegistration] = useState<ConfirmedRegistration | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!registrationId) {
      setError('Link de confirmação inválido.');
      return;
    }

    let active = true;
    consultarInscricaoConfirmada(registrationId)
      .then((data) => active && setRegistration(data))
      .catch((requestError) => {
        if (active) setError(requestError instanceof Error ? requestError.message : 'Erro ao carregar confirmação.');
      });

    return () => {
      active = false;
    };
  }, [registrationId]);

  return (
    <div className="uba-form-page">
      <div className="uba-container success-page-container">
        <header className="uba-header">
          <img src="/logo-compact.webp" alt="Colônia de Férias - UBA Clube" className="uba-header-logo" />
        </header>

        {registration ? (
          <SuccessScreen
            form={{
              nomeCompleto: registration.nomeCompleto,
              telefoneMae: registration.telefoneMae,
              gratuito: registration.gratuito
            }}
            valorTotal={registration.valorTotal}
            premios={registration.premios}
            onNew={() => navigate('/inscricao')}
          />
        ) : (
          <div className="success-overlay">
            <div className="success-container success-status-message">
              <h1 className="success-title">{error ? 'Confirmação indisponível' : 'Carregando confirmação...'}</h1>
              {error && <p className="success-subtitle">{error}</p>}
              {error && <button type="button" className="btn-new-registration" onClick={() => navigate('/inscricao')}>Voltar para inscrição</button>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PagamentoSucesso;
